import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-md";

const GroupRegistrationButton = ({
  thereIsSelectedRegistration,
  overMaxMember,
}) => {
  return thereIsSelectedRegistration ? (
    overMaxMember ? (
      <Button
        flat
        disabled={true}
        className="group-registration-button--warning"
        label="TOO MANY PEOPLE"
      />
    ) : (
      <Button flat className="group-registration-button">
        Group
      </Button>
    )
  ) : (
    <Button flat disabled={true}>
      Group
    </Button>
  );
};

GroupRegistrationButton.propTypes = {
  thereIsSelectedRegistration: PropTypes.bool,
  overMaxMember: PropTypes.bool,
};

export default GroupRegistrationButton;



// WEBPACK FOOTER //
// ./src/staff/components/Queue/Registration/GroupRegistrationButton.jsx